import axios, { AxiosResponse, CancelToken } from "axios"
import { cesionAdapter, cesionByIdAdapter } from "./Cesion.adapter"
import { AceptarCesionCommandProps } from "./Commands/AceptarCesionCommand"
import { GetCesionByIdDtoProps } from "./DTOs/GetCesionByIdDto"
import { GetCesionByFiltersDtoIPagedEnumerableProps } from "./Schemas/GetCesionByFiltersDtoIPagedEnumerable"
import { EstadoCesionType } from "./Types/EstadoCesion"

type CesionEstado = 1 | 2 | 3 | 4 | 5 | 6 | 7
type SortingCriteria = {
  sort?: "ASC" | "DESC"
  property?: string
}

export interface CesionQueryParamsProps {
  EmpresaId?: string
  Estados?: Array<EstadoCesionType>
  Keyword?: string
  SortingCriteria: SortingCriteria
  MaxResultCount?: number
  SkipCount?: number
}

export async function getCesionesByFilter(
  queryParam: CesionQueryParamsProps,
  cancelToken?: CancelToken
): Promise<GetCesionByFiltersDtoIPagedEnumerableProps> {
  const { data }: { data: GetCesionByFiltersDtoIPagedEnumerableProps } =
    await axios.get("/Cesion/", {
      params: queryParam,
      cancelToken,
    })
  return {
    currentPage: data.currentPage,
    items: data?.items?.map((cesion) => cesionAdapter(cesion)),
    totalCount: data.totalCount,
  }
}

/**
 * @description Check if User has any Cesion
 * @returns {Boolean}
 */
export async function hasAnyCesion(
  queryParams?: CesionEstado[]
): Promise<boolean> {
  const { data }: Record<"data", boolean> = await axios.get("/Cesion/any", {
    params: queryParams,
  })
  return data
}
export async function isFirstCesion(): Promise<boolean> {
  const { data }: Record<"data", boolean> = await axios.get(
    "/Cesion/any-estado-actualizado"
  )
  return data
}

export async function getCesionById(
  id: string
): Promise<GetCesionByIdDtoProps> {
  const { data }: { data: GetCesionByIdDtoProps } = await axios.get(
    `/Cesion/${id}`
  )
  return cesionByIdAdapter(data)
}

export async function postCesionAceptar(
  id: string,
  cesion: AceptarCesionCommandProps
): Promise<AxiosResponse> {
  const response = await axios.post(`/Cesion/${id}/aceptar`, cesion)
  return response
}
